<div class="container">
    <h1>
        Forslag til tiltak ({{ antallTiltak() }})
    </h1>
    <p class="description">
        Nå kan du se hvilke tiltak vi anbefaler for din bolig.
    </p>
    @for (tiltak of tiltakListe(); track tiltak.id) {
        <bko-tiltak-card [tiltak]="tiltak" [besvarelseId]="besvarelseId()"></bko-tiltak-card>
    }
</div>
